import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { OutboundWebhookProtocol } from './outbound-webhook-protocol.js';
import { OutboundWebhookStrategy } from './outbound-webhook-strategy.js';

export class OkeokeProductsOutboundWebhookProtocol extends OutboundWebhookProtocol {
  static readonly TYPE_ID: string = '48d176b449d447a5ad3eeb2214a0322b';

  public readonly strategy: OutboundWebhookStrategy = OutboundWebhookStrategy.OkeokeProducts;

  private constructor(
  ) {
    super();
  }

  get $typeId(): string {
    return OkeokeProductsOutboundWebhookProtocol.TYPE_ID;
  }

  static create(): OkeokeProductsOutboundWebhookProtocol {
    return new OkeokeProductsOutboundWebhookProtocol();
  }

  static fromMap(context: SerializationContext, map: SerializedData): OkeokeProductsOutboundWebhookProtocol {
    return new OkeokeProductsOutboundWebhookProtocol();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'strategy': fromEnumAsString(this.strategy),
    };
  }

  clone(): this {
    return new OkeokeProductsOutboundWebhookProtocol() as this;
  }

  isSame(other: OkeokeProductsOutboundWebhookProtocol): boolean {
    if(this === other) {
      return true;
    }

    return other.strategy === this.strategy;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof OkeokeProductsOutboundWebhookProtocol;
  }

  static assertType(order: DataModel): order is OkeokeProductsOutboundWebhookProtocol {
    return order instanceof OkeokeProductsOutboundWebhookProtocol;
  }
}

export class OkeokeProductsOutboundWebhookProtocolBuilder extends DataModelBuilder<OkeokeProductsOutboundWebhookProtocol> {
  build(context: SerializationContext, map: SerializedData): OkeokeProductsOutboundWebhookProtocol {
    return OkeokeProductsOutboundWebhookProtocol.fromMap(context, map);
  }
}
